import React, { createContext, useContext, useState, useCallback } from 'react';

const HeaderInfoContext = createContext({
  headerInfo: null,
  refreshHeaderInfo: () => {},
});

export const useHeaderInfoContext = () => {
  const context = useContext(HeaderInfoContext);
  if (!context) {
    throw new Error('useHeaderInfoContext must be used within a HeaderInfoContextProvider');
  }
  return context;
};

export const HeaderInfoContextProvider = ({ children, initialHeaderInfo, onHeaderInfoRefresh }) => {
  const [headerInfo, setHeaderInfo] = useState(initialHeaderInfo);

  const refreshHeaderInfo = useCallback(async () => {
    try {
      // Call the refresh function passed from parent
      if (onHeaderInfoRefresh) {
        const newHeaderInfo = await onHeaderInfoRefresh();
        setHeaderInfo(newHeaderInfo);
        return newHeaderInfo;
      }
    } catch (error) {
      console.error('Failed to refresh header information:', error);
      throw error;
    }
  }, [onHeaderInfoRefresh]);

  const contextValue = {
    headerInfo,
    refreshHeaderInfo,
    setHeaderInfo, // Allow direct setting if needed
  };

  return (
    <HeaderInfoContext.Provider value={contextValue}>
      {children}
    </HeaderInfoContext.Provider>
  );
};

export default HeaderInfoContext;